import styled from "styled-components";

export const AuthSection = styled.section``;

export const FormErrContainer = styled.span`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1rem;

  & > * {
    margin-left: auto;
    margin-right: auto;
  }
`;
